import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { Capacitor } from "@capacitor/core";
import { getEnvironment } from "./config/environment";

// Native builds always target production (see config/environment.ts); on web,
// getEnvironment() reads the hostname, which is "localhost" inside Capacitor.
const sentryEnvironment = Capacitor.isNativePlatform()
  ? "production"
  : ({ local: "development", testing: "staging", production: "production" } as const)[getEnvironment()];

if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  Sentry.init({
    // DSN is public (it ships in the bundle); the literal is a fallback for
    // CI builds where REACT_APP_SENTRY_DSN isn't configured.
    dsn: process.env.REACT_APP_SENTRY_DSN || "https://d93e38358f4e34f7e102058a8f9efd7e@o4510317447020544.ingest.de.sentry.io/4511093771075665",
    environment: sentryEnvironment,
    integrations: [
      SentryReact.browserTracingIntegration(),
      SentryReact.replayIntegration(),
    ],
    tracesSampleRate: sentryEnvironment === "production" ? 0.2 : 1.0,
    tracePropagationTargets: [/^https:\/\/luminous-app.onrender.com/],
    // Error-only replay: no ambient session recording (privacy decision),
    // full replay attached when an error occurs.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  }, SentryReact.init);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only use StrictMode in production to avoid double API calls in development
const isProduction = process.env.NODE_ENV === 'production';

root.render(
  isProduction ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
